import Card from '@/components/Common/Card';

export default {
  name: 'ComplainsInfo',
  
  components: { Card },

};



// WEBPACK FOOTER //
// ./src/components/Complains/ComplainsInfo/component.js